import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import Link from 'components/consumer/Link';
import classNames from 'classnames';
import categoryPhotoImgixProps from './categoryPhotoImgixProps';
const DesktopNavCategorySectionImage = t0 => {
  const $ = _c(14);
  const {
    description,
    descriptionTextColor: t1,
    image,
    label,
    to
  } = t0;
  const descriptionTextColor = t1 === undefined ? "dark" : t1;
  if (image) {
    let t2;
    if ($[0] !== image || $[1] !== label) {
      t2 = <JBImage aria-label={label} className="w-full" src={image} {...categoryPhotoImgixProps} />;
      $[0] = image;
      $[1] = label;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== description || $[4] !== descriptionTextColor) {
      t3 = !!description && descriptionTextColor === "light" && <div className="[background:linear-gradient(rgba(0,0,0,.25)_,transparent_75%)] bottom-0 h-full left-0 absolute right-0 top-0 w-full" />;
      $[3] = description;
      $[4] = descriptionTextColor;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== description || $[7] !== descriptionTextColor) {
      t4 = !!description && <div className={classNames("text-xl font-bold text-gray left-0 p-6 absolute right-0 top-0 w-full", {
        "text-brand-lightest": descriptionTextColor === "light"
      })}>{description}</div>;
      $[6] = description;
      $[7] = descriptionTextColor;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== to) {
      t5 = <Link className="flex relative w-full" to={to} aria-hidden="true" tabIndex="-1">{t2}{t3}{t4}</Link>;
      $[9] = t2;
      $[10] = t3;
      $[11] = t4;
      $[12] = to;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    return t5;
  }
  return null;
};
DesktopNavCategorySectionImage.propTypes = {
  description: PropTypes.string,
  descriptionTextColor: PropTypes.oneOf(['light', 'dark']),
  image: PropTypes.string,
  label: PropTypes.string,
  to: PropTypes.string
};
export default DesktopNavCategorySectionImage;